import AppDispatcher from '../dispatcher/AppDispatcher';
import * as ActionConstants from '../constants/';

  export function changeLocale(locale) {
    AppDispatcher.handleViewAction({
      actionType:ActionConstants.CHANGE_LOCALE,
      locale
    });
  }
  export function resetHelp() {
    AppDispatcher.handleViewAction({
      actionType:ActionConstants.RESET_HELP
    });
  }
  export function toggleHelp() {
    AppDispatcher.handleViewAction({
      actionType:ActionConstants.TOGGLE_HELP
    });
  }

  export function lockChartsData() {
    AppDispatcher.handleViewAction({
      actionType:ActionConstants.REQ_DATA
    });
  }


  export function unlockChartsData() {
    AppDispatcher.handleViewAction({
      actionType:ActionConstants.RES_DATA
    });
  }



// WEBPACK FOOTER //
// ./src/actions/index.js